import { Palette } from '@/themes/themeOverrides/Palette';
import ErrorIcon from '@/assets/icons/error-icon.svg';
import SuccessIcon from '@/assets/icons/success-icon.svg';
import WarningIcon from '@/assets/icons/warning-icon.svg';
import InfoIcon from '@/assets/icons/alert-info-icon.svg';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const MuiSnackbarStyles = {
    styleOverrides: {
        root: {
            bottom: 'unset !important',
            top: '50px !important',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                width: 'calc(100% - 40px) !important',
            },
            '& .MuiPaper-root': {
                width: '100%',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                letterSpacing: '-0.14px',
                boxShadow: Palette.boxShadow.elevation6,
                borderRadius: '16px',
                padding: '17px 18px 17px 58px',
                border: '1px solid transparent',
                position: 'relative',
                backgroundColor: Palette.green.green50,
                borderColor: Palette.green.green100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '24px',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '12px',
                    minWidth: '100%',
                },
                '&.RaNotification-success': {
                    backgroundColor: Palette.green.green50,
                    borderColor: Palette.green.green100,
                    '& .MuiSnackbarContent-message': {
                        '&::before': {
                            backgroundImage: `url("${SuccessIcon}")`,
                        },
                    },
                },
                '&.RaNotification-error': {
                    backgroundColor: Palette.red.red50,
                    borderColor: Palette.red.red100,
                    '& .MuiSnackbarContent-message': {
                        '&::before': {
                            backgroundImage: `url("${ErrorIcon}")`,
                        },
                    },
                },
                '&.RaNotification-warning': {
                    backgroundColor: Palette.yellow.yellow50,
                    borderColor: Palette.yellow.yellow100,
                    '& .MuiSnackbarContent-message': {
                        '&::before': {
                            backgroundImage: `url("${WarningIcon}")`,
                        },
                    },
                },
                '&.RaNotification-info': {
                    backgroundColor: Palette.blue.blue50,
                    borderColor: Palette.blue.blue100,
                    '& .MuiSnackbarContent-message': {
                        '&::before': {
                            backgroundImage: `url("${InfoIcon}")`,
                        },
                    },
                },
                '& .MuiSnackbarContent-message': {
                    color: Palette.black,
                    padding: '0',
                    '&::before': {
                        content: '""',
                        width: '24px',
                        height: '24px',
                        display: 'block',
                        position: 'absolute',
                        left: '20px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundImage: `url("${SuccessIcon}")`,
                        backgroundSize: '100% auto',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    },
                },
                '& .MuiSnackbarContent-action': {
                    margin: 0,
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        padding: '0 !important',
                    },
                    '& .MuiButton-root': {
                        fontSize: '11px',
                        padding: '8px 12px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '16px',
                        letterSpacing: '-0.11px',
                        borderRadius: '8px',
                        backgroundColor: Palette.white,
                        boxShadow: Palette.boxShadow.elevation1,
                        '&:hover': {
                            backgroundColor: Palette.white,
                            boxShadow: Palette.boxShadow.elevation2,
                        },
                    },
                },
            },
        },
    },
};
